import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import MyGames from './pages/MyGames';
import GameDetail from './pages/GameDetail';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen" style={{ background: 'linear-gradient(to bottom right, #6B21A8, #7C3AED, #8B5CF6)' }}>
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/my-games" element={<MyGames />} />
            <Route path="/game/:id" element={<GameDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
